@if (!loading) {
  <div class="contest-lessons__wrapper">
    @if (canCompete) {
      <app-contest-header
        [contest]="contest">
      </app-contest-header>
    }
    <div class="contest-lessons__content"
      [ngClass]="{'contest-lessons__content--border-radius': !canCompete}">
      <mat-tab-group class="contest-lessons__tab-group"
        (selectedIndexChange)="onTabChange($event)">
        @for (subLesson of subLessons; track subLesson) {
          <mat-tab appAriaTitle
            label="{{ subLesson?.get('metadatas')?.title }}">
            <ul class="contest-lessons__list">
              @for (activity of activities[subLesson.id]; track activity; let i = $index) {
                <li
                  class="contest-lessons__item">
                  <app-activty-card class="contest-lessons__card"
                    [isActivitiesIsDone]="isActivityDone(activity)"
                    [title]="activity.get('metadatas').title"
                    [image]="getActivityTypeImage(activity)"
                    [subLesson]="subLesson"
                    [i]="i"
                    (playEvent)="playEvent($event)">
                  </app-activty-card>
                </li>
              }
            </ul>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
} @else {
  <div class="contest-lessons__spinner-wrapper">
    <mat-spinner></mat-spinner>
  </div>
}

